import { render } from "./Meeting.vue?vue&type=template&id=5c28ea52"
import script from "./Meeting.vue?vue&type=script&lang=js"
export * from "./Meeting.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__